import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LabelValue from '../../LabelValue';
import { User } from '../../../data/models/user.model';
import { useActiveStatus } from '../../../hooks/useActiveStatus';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface BasicInfoProps {
  user: User | null;
  titleStyle: string;
}

export default function BasicInfo(props: BasicInfoProps) {
  const { t } = useTranslation('common');

  const { user, titleStyle } = props;

  return (
    <>
      <Typography className={titleStyle}>{t('user.attributes')}</Typography>
      <Grid container spacing={2} className={FULLSTORY_MASK_CLASSNAME}>
        <Grid item sm={12} md={6}>
          <LabelValue label={t('user.firstName')} value={user?.userFirstName} />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('user.middleName')}
            value={user?.userMiddleName || undefined}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue label={t('user.lastName')} value={user?.userLastName} />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue label={t('user.email')} value={user?.emailAddress} />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('common.status')}
            value={useActiveStatus(user?.userAccountState)}
          />
        </Grid>
      </Grid>
    </>
  );
}
